const qs = require('querystring')
const CACHE = {}

module.exports = function cacheify (method) {
  return function (...args) {
    const arity = method.length
    const params = args.slice(0, arity)
    const shouldCache = args.length > arity && !!args[arity]

    const cacheKey = params.reduce((prev, curr) => {
      if (typeof curr === 'object') {
        return prev + qs.stringify(curr)
      } else {
        return prev + curr.toString()
      }
    }, '')

    if (shouldCache && cacheKey in CACHE) {
      return Promise.resolve(CACHE[cacheKey])
    }

    return method.apply(this, params)
      .then((res) => {
        CACHE[cacheKey] = res
        return res
      })
  }
}
